import { createFileRoute } from '@tanstack/react-router';

import { Photos } from '@/view/pages/Photos';

export const Route = createFileRoute('/_protected/$programId/fotos')({
  component: Photos,
  context: (context): { title: string } => ({
    ...context,
    title: 'Fotos',
  }),
});
